export var PARA_GRUPO_ID = 3;
export var INST_CODIGO_GERAL = '000';
export var AMBI_TIPO_IDS = {
    prod: 1,
    homolog: 2,
    dev: 3,
    demo: 4
};
export var SUBDOMINIO_PADRAO = 'www';
export var BUI_PARAMETROS_CHAVES = {
    logoUrl: 'LOGO_URL',
    clientName: 'WEB_NAME',
    faviconUrl: 'FAVICON_URL',
    iconUrl: 'ICONE_URL',
    emailSuporte: 'APP_EMAIL_SUPPORT',
    exibirCentralAjuda: 'EXIBIR_CENTRAL_AJUDA',
    urlPlayStore: 'URL_PLAY_STORE',
    urlAppStore: 'URL_APP_STORE',
    telaLoginTextoDeDicaDeUsuario: 'TELA_LOGIN_TEXTO_DE_DICA_DE_USUARIO',
    telaLoginTextoDeDicaDeSenha: 'TELA_LOGIN_TEXTO_DE_DICA_DE_SENHA',
    telaLoginUrlPrecisaAjuda: 'TELA_LOGIN_URL_PRECISA_AJUDA',
    telaLoginPlaceholderAluno: 'TELA_LOGIN_PLACEHOLDER_ALUNO',
    telaLoginPlaceholderProfessor: 'TELA_LOGIN_PLACEHOLDER_PROFESSOR',
    telaLoginPlaceholderGestor: 'TELA_LOGIN_PLACEHOLDER_GESTOR',
    telaLoginPlaceholderOutros: 'TELA_LOGIN_PLACEHOLDER_OUTROS',
};
